import { IntegrationLogFilters, IntegrationLogTab, Pagination } from '../../../types';

export function buildDefaultLogRange(): Pick<IntegrationLogFilters, 'from' | 'to'> {
  const to = new Date();
  const from = new Date(to.getTime() - 24 * 60 * 60 * 1000);
  return {
    from: from.toISOString(),
    to: to.toISOString(),
  };
}

export function toDatetimeLocalValue(iso: string): string {
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return '';
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function fromDatetimeLocalValue(value: string): string {
  if (!value) return '';
  return new Date(value).toISOString();
}

export type IntegrationLogPaginationInput = Partial<Pagination> & { totalPages?: number };

export function normalizeIntegrationLogPagination(
  raw?: IntegrationLogPaginationInput | null,
): Pagination {
  return {
    page: raw?.page ?? 1,
    limit: raw?.limit ?? 20,
    total: raw?.total ?? 0,
    pages: raw?.pages ?? raw?.totalPages ?? 0,
  };
}

export function filtersToQueryParams(
  tab: IntegrationLogTab,
  filters: IntegrationLogFilters,
): Record<string, string | number | undefined> {
  const base: Record<string, string | number | undefined> = {
    from: filters.from,
    to: filters.to,
    page: filters.page ?? 1,
    limit: filters.limit ?? 20,
  };

  if (tab === 'webhooks') {
    if (filters.processed) base.processed = filters.processed;
    if (filters.status) base.status = filters.status;
    if (filters.transactionId) base.transactionId = filters.transactionId;
    if (filters.orderNumber) base.orderNumber = filters.orderNumber;
    return base;
  }

  if (filters.providerCode) base.providerCode = filters.providerCode;
  if (filters.apiMethod) base.apiMethod = filters.apiMethod;
  if (filters.success) base.success = filters.success;
  if (filters.userId) base.userId = filters.userId;
  if (filters.gameProviderId) base.gameProviderId = filters.gameProviderId;
  if (filters.paymentTransactionId) base.paymentTransactionId = filters.paymentTransactionId;
  if (filters.transactionId) base.transactionId = filters.transactionId;
  if (filters.referenceId) base.referenceId = filters.referenceId;
  if (filters.requestUrl) base.requestUrl = filters.requestUrl;
  if (filters.minDurationMs) base.minDurationMs = filters.minDurationMs;

  return base;
}

export function parseFiltersFromSearchParams(
  searchParams: URLSearchParams,
): { tab: IntegrationLogTab; filters: IntegrationLogFilters } {
  const tabParam = searchParams.get('tab');
  const tab: IntegrationLogTab =
    tabParam === 'payment' || tabParam === 'webhooks' ? tabParam : 'game';

  const defaults = buildDefaultLogRange();

  return {
    tab,
    filters: {
      ...defaults,
      page: 1,
      limit: 20,
      userId: searchParams.get('userId') || undefined,
      gameProviderId: searchParams.get('gameProviderId') || undefined,
      transactionId: searchParams.get('transactionId') || undefined,
      paymentTransactionId: searchParams.get('paymentTransactionId') || undefined,
      referenceId: searchParams.get('referenceId') || undefined,
      providerCode: searchParams.get('providerCode') || undefined,
      success: searchParams.get('success') || undefined,
      processed: searchParams.get('processed') || undefined,
    },
  };
}
